<div class="flex flex-col justify-start text-md w-[374px] gap-3">
    <div class="flex flex-col w-full shadow text-slate-50 bg-ponder-light rounded-md">
        <div class="flex flex-row gap-2 pl-2 pr-2 pt-2 pb-1">
            {{ username }}'s Collection
        </div>
        <div class="pb-1">
            <table class="table-auto text-xs text-slate-200 truncate rounded-b-md">
                <tbody>
                    <tr class="bg-ponder-xlight rounded-b-md">
                        <td class="pl-2 pr-2">{{ getDistinctCollectedCount() }} unique cards</td>
                        <td class="pl-2 pr-2">{{ getCollectedCount() }} total cards</td>
                        <td class="pl-2 pr-2 w-full">
                            {{ getCollectedValue() }} value
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
</div>